import { getAnalytics, logEvent } from 'firebase/analytics';

const analytics = getAnalytics();

export const logPerformance = (action, duration, details = {}) => {
  logEvent(analytics, 'performance_measure', {
    action,
    duration,
    ...details
  });
};

export const measurePerformance = async (action, func) => {
  const start = performance.now();
  let result;
  try {
    result = await func();
  } finally {
    const duration = performance.now() - start;
    logPerformance(action, duration);
  }
  return result;
};

export const createPerformanceLogger = (prefix) => {
  return {
    start: (label) => {
      const startTime = performance.now();
      return () => {
        const duration = performance.now() - startTime;
        logPerformance(`${prefix}_${label}`, duration);
      };
    },
    measure: async (label, func) => {
      return measurePerformance(`${prefix}_${label}`, func);
    }
  };
};

export const logFunctionCall = async (functionName, callFunction) => {
  const start = performance.now();
  try {
    const result = await callFunction();
    const duration = performance.now() - start;
    logPerformance(`frontend_${functionName}_call`, duration);
    return result;
  } catch (error) {
    const duration = performance.now() - start;
    logPerformance(`frontend_${functionName}_call_error`, duration, { error: error.message });
    throw error;
  }
};